import React, { useEffect } from 'react';
import Header from '../Components/Login/Header';
import {Outlet, useNavigate} from 'react-router-dom';
import Auth from "../Helper/Auth";
import { useSelector} from 'react-redux';

const LoginLayout = ({ props }) => {
  const navigation = useNavigate();
  const apiToken = useSelector(store => store.user['token'])
  const loggedUser = useSelector(store => store.user['user'])
  useEffect(() => {
    if(apiToken){
      if(loggedUser.user_role==2)
      {
        navigation("/Exhibitorhome");
      } else if(loggedUser.user_role==1)
      {
        navigation("/");
      }
    }
  },[apiToken]); 

    return (
    <>
     <Header/>
     <main style={{ padding: '1rem 0' }}>
      <Outlet />
    </main>
    {/* <Footer/> */}
    </>)
  };

  export default LoginLayout;